import type { CSSProperties } from 'react';
import { layout } from '../../theme/tokens';
import { Wrapper, LeftSide, RightSide, ContentInner } from './SplitLayout.styles';
import type { SplitLayoutProps } from './SplitLayout.types';

export function SplitLayout({
  left,
  right,
  leftWidth = '58%',
  height = `calc(100vh - ${layout.headerHeightDesktop})`,
  contentMaxWidth = '480px',
  contentGap = '64px',
}: SplitLayoutProps) {
  const wrapperStyle = {
    '--split-height': height,
  } as CSSProperties;

  const leftStyle = {
    '--split-left-width': leftWidth,
  } as CSSProperties;

  const rightStyle = {
    '--split-right-width': `calc(100% - ${leftWidth})`,
  } as CSSProperties;

  const innerStyle = {
    '--split-content-max-width': contentMaxWidth,
    '--split-content-gap': contentGap,
  } as CSSProperties;

  return (
    <Wrapper style={wrapperStyle}>
      <LeftSide style={leftStyle}>{left}</LeftSide>
      <RightSide style={rightStyle}>
        <ContentInner style={innerStyle}>{right}</ContentInner>
      </RightSide>
    </Wrapper>
  );
}
